export const APP_NAME = 'KUOW Connect';
export const VERSION = '1.0.0';

// Storage keys
export const STORAGE_KEYS = {
  AUTH_TOKEN: 'kuow_auth_token',
  USER_PREFERENCES: 'kuow_user_preferences',
} as const;

// API endpoints
export const API_ENDPOINTS = {
  USER_TOKEN: '/v1/user_token',
  USER_EXCHANGE_TOKEN: '/v1/exchange_token',
  USER_PROFILE: '/v1/users/me',
  USER_RECOVERY_REQUESTS: '/v1/users/recovery_requests',
  USER_RESET_PASSWORD: '/v1/users/reset_password',
  DONATION_FORMS: '/donate/v1/forms',
  DONATIONS: '/donate/v1/donations',
  CAMPAIGNS: '/donate/v2/campaigns',
  STORY_FEEDBACK: '/v2/feedback',
  SUPPORT_CASES: '/v1/support/cases/',
  NEWSLETTER_SUBSCRIPTIONS: '/v1/newsletter_subscriptions',
} as const;

// Widget configuration
export const WIDGET_CONFIG = {
  DEFAULT_THEME: 'light',
  SUPPORTED_THEMES: ['light', 'dark'],
  MAX_RETRY_ATTEMPTS: 3,
} as const; 